// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checklist-checklist-common-data-dialog .dialog-heading-label {
  font-size: 20px;
  margin-bottom: 7px;
}
.fi-checklist-checklist-common-data-dialog .dialog-description-label {
  font-size: 16px;
  margin-bottom: 29px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/checklist/fi-checklist2-edit/checklist-common-data-dialog/checklist-common-data-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,kBAAA;AAAR;AAEI;EACI,eAAA;EACA,mBAAA;AAAR","sourcesContent":[".fi-checklist-checklist-common-data-dialog {\r\n    .dialog-heading-label {\r\n        font-size: 20px;\r\n        margin-bottom: 7px;\r\n    }\r\n    .dialog-description-label {\r\n        font-size: 16px;\r\n        margin-bottom: 29px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
